export const MeetLocationType = "integrations:google:meet";

export const MSTeamsLocationType = "integrations:office365_video";

export const DailyLocationType = "integrations:daily";
